import React from 'react';
import { Field } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import MoneyField from '../money-field';
import FormField from '../form-field';
import { Invitees } from './invitees';

import '../../css/invitees.css';

class InviteesWithShare extends Invitees {
  constructor(props) {
    super(props);
    this.onEmailFocus = this.onEmailFocus.bind(this);
  }

  onEmailFocus() {
    this.props.onEmailFocus();
  }

  getShareProps(invitee, config = {}) {
    const props = {
      name: `${invitee}.allowedShareAmount`,
      currency: this.props.currency,
    };

    if (config.first) {
      return {
        ...props,
        label: <FormattedMessage
          id="claimForm.invitees.shareField.label"
          defaultMessage="Share"
        />,
      };
    }

    if (config.last) {
      return {
        ...props,
        onBlur: this.props.onInviteesChange,
      }
    }

    return { ...props };
  }

  renderFirstInviteeRow(invitee) {
    const first = { first: true };
    return inviteeRow(invitee, this.getEmailProps(invitee, first),
      this.getNameProps(invitee, first), this.getShareProps(invitee, first));
  }

  renderInviteeRow(invitee) {
    return inviteeRow(invitee, this.getEmailProps(invitee),
      this.getNameProps(invitee), this.getShareProps(invitee));
  }

  renderLastInviteeRow(invitee) {
    const last = true;
    return inviteeRow(invitee, this.getEmailProps(invitee, { last }),
      this.getNameProps(invitee, { last }), this.getShareProps(invitee, { last }));
  }

}

const inviteeRow = (invitee, emailProps, nameProps, shareProps) => {
  return (
    <div className="row" key={invitee}>
      <div className="col-5" key={`invitee-row-${invitee}-email`}>
        <Field {...emailProps} type="text" component={FormField} />
      </div>
      <div className="col-4" key={`invitee-row-${invitee}-name`}>
        <Field {...nameProps} type="text" component={FormField} />
      </div>
      <div className="col-3" key={`invitee-row-${invitee}-share`}>
        <MoneyField {...shareProps} component={FormField} />
      </div>
    </div>
  );
}
export default injectIntl(InviteesWithShare);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/invitees.with-share.js